var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"answer"},[(_vm.status && _vm.isNotAnswerTime)?_c('event-message'):_c('answer-sheet')],1)}
var staticRenderFns = []

export { render, staticRenderFns }